module.exports = __webpack_public_path__ + "img/Edit.811663f4.svg";